<template lang="pug">
  div
    .text-xl.font-semibold.mb-4.neutral700--text What do you want to do?
    v-card.pa-4.round-xl.mb-3.card-border(v-for="todo in todoItems" :key="todo.id" :disabled="isDisabled(todo)" outlined @click="handleSelectedItem(todo)")
      .d-flex.align-center.justify-space-between
        .d-flex.align-center
          v-icon.mr-4(color="neutral700") {{ todo.icon }}
          .text-md.font-medium {{ todo.title }}
        v-btn(icon color="neutral700")
          v-icon mdi-chevron-right
    .dialogs
      collect-value-dialog(v-if="openCollectValueDialog" :open.sync="openCollectValueDialog" :loyaltySystem="loyaltySystem" :profile="profile" @backToCollectPage="handleBackToCollectPage" @redeem="handleRedeem")
      redeem-reward-dialog(v-if="openRedeemRewardDialog" :open.sync="openRedeemRewardDialog" :loyaltySystem="loyaltySystem" :profile="profile" @redeemed="$emit('redeemed')")
</template>

<script>
import CollectValueDialog from "@/components/marketing/merchantapp/dialogs/CollectValueDialog.vue";
import RedeemRewardDialog from "@/components/marketing/merchantapp/dialogs/RedeemRewardDialog.vue";

export default {
  components: {
    RedeemRewardDialog,
    CollectValueDialog
  },
  props: {
    loyaltySystem: {
      type: String,
      required: true
    },
    profile: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedItem: null,
      openCollectValueDialog: false,
      openRedeemRewardDialog: false,
    }
  },
  computed: {
    todoItems() {
      return [
        {
          id: 'collect',
          icon:  this.loyaltySystem === 'stamps' ? '$yzi-award-02' : '$yzi-coins-hand',
          title: `Collect ${this.loyaltySystem}`
        },
        {
          id: 'redeem',
          icon: '$yzi-gift-02',
          title: 'Redeem rewards'
        }
      ]
    }
  },
  methods: {
    handleSelectedItem(item) {
      this.selectedItem = item
      if (item.id === 'collect') {
        this.openCollectValueDialog = true
        return
      }
      this.openRedeemRewardDialog = true
    },
    handleBackToCollectPage() {
      this.openCollectValueDialog = false
      this.$emit('backToCollectPage')
    },
    handleRedeem() {
      this.openCollectValueDialog = false
      this.openRedeemRewardDialog = true
    },
    isDisabled(item) {
      if (item.id === 'collect' && this.loyaltySystem === 'stamps') {
        return this.profile?.collected === 10
      }
      if (item.id === 'redeem') {
        return this.profile?.available_rewards?.length === 0
      }
      return false
    }
  },
}
</script>

<style scoped>
.card-border {
  border: 1px solid #C1C1C1 !important;
}
</style>